import { render, staticRenderFns } from "./AddCampaigns.vue?vue&type=template&id=1bb2a974&scoped=true"
import script from "./AddCampaigns.vue?vue&type=script&lang=js"
export * from "./AddCampaigns.vue?vue&type=script&lang=js"
import style0 from "./AddCampaigns.vue?vue&type=style&index=0&id=1bb2a974&prod&scoped=true&lang=css"
import style1 from "./AddCampaigns.vue?vue&type=style&index=1&id=1bb2a974&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb2a974",
  null
  
)

export default component.exports